import { GlDisclosureDropdown, GlDisclosureDropdownGroup, GlNavItem, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import HelpCenterUpgradeSubscription from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/super_sidebar/components/help_center_upgrade_subscription.vue?vue3';
import GitlabVersionCheckBadge from '/builds/gitlab/gitlab-ee/app/assets/javascripts/gitlab_version_check/components/gitlab_version_check_badge.vue?vue3';
import { helpPagePath } from '~/helpers/help_page_helper';
import { helpDocsPath } from '~/lib/utils/path_helpers/help';
import { termsPath } from '~/lib/utils/path_helpers/user';
import { FORUM_URL, PROMO_URL, CONTRIBUTE_URL, UNIVERSITY_URL } from '~/constants';
import { __ } from '~/locale';
import Tracking from '/builds/gitlab/gitlab-ee/app/assets/javascripts/tracking/index.js?vue3';
import WhatsNewForYouMenuItem from '/builds/gitlab/gitlab-ee/app/assets/javascripts/whats_new/components/whats_new_for_you_menu_item.vue?vue3';
import { HELP_MENU_TRACKING_DEFAULTS } from '../constants';
export default {
    name: 'HelpCenter',
    WHATS_NEW_TRACKING_PROPERTY: HELP_MENU_TRACKING_DEFAULTS['data-track-property'],
    components: {
        GlDisclosureDropdown,
        GlDisclosureDropdownGroup,
        GlNavItem,
        GitlabVersionCheckBadge,
        HelpCenterUpgradeSubscription,
        WhatsNewForYouMenuItem
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        Tracking.mixin({
            property: 'nav_help_menu'
        })
    ],
    i18n: {
        help: __('Help'),
        support: __('Support'),
        docs: __('GitLab documentation'),
        plans: __('Compare GitLab plans'),
        forum: __('GitLab community forum'),
        university: __('GitLab University'),
        contribute: __('Contribute to GitLab'),
        feedback: __('Provide feedback'),
        shortcuts: __('Keyboard shortcuts'),
        version: __('Your GitLab version'),
        terms: __('Terms and privacy'),
        privacy: __('Privacy statement')
    },
    inject: [
        'isSaas',
        'isIconOnly'
    ],
    props: {
        sidebarData: {
            type: Object,
            required: true
        }
    },
    computed: {
        showUpgradeSubscription () {
            return Boolean(this.sidebarData.free_group_upgrade_link);
        },
        showWhatsNew () {
            return !this.sidebarData.is_logged_in;
        },
        itemGroups () {
            const groups = {
                helpLinks: {
                    items: [
                        {
                            text: this.$options.i18n.help,
                            href: helpPagePath(),
                            extraAttrs: {
                                ...this.trackingAttrs('help')
                            }
                        },
                        {
                            text: this.$options.i18n.support,
                            href: this.sidebarData.support_path,
                            extraAttrs: {
                                ...this.trackingAttrs('support')
                            }
                        },
                        {
                            text: this.$options.i18n.docs,
                            href: helpDocsPath({
                                organizationPath: null
                            }),
                            extraAttrs: {
                                ...this.trackingAttrs('gitlab_documentation')
                            }
                        },
                        {
                            text: this.$options.i18n.university,
                            href: UNIVERSITY_URL,
                            extraAttrs: {
                                ...this.trackingAttrs('gitlab_university')
                            }
                        },
                        {
                            text: this.$options.i18n.plans,
                            href: this.sidebarData.compare_plans_url,
                            extraAttrs: {
                                ...this.trackingAttrs('compare_gitlab_plans')
                            }
                        },
                        {
                            text: this.$options.i18n.forum,
                            href: FORUM_URL,
                            extraAttrs: {
                                ...this.trackingAttrs('community_forum')
                            }
                        },
                        {
                            text: this.$options.i18n.contribute,
                            href: CONTRIBUTE_URL,
                            extraAttrs: {
                                ...this.trackingAttrs('contribute_to_gitlab')
                            }
                        },
                        {
                            text: this.$options.i18n.feedback,
                            href: `${PROMO_URL}/submit-feedback`,
                            extraAttrs: {
                                ...this.trackingAttrs('submit_feedback')
                            }
                        },
                        this.isSaas && {
                            text: this.$options.i18n.privacy,
                            href: `${PROMO_URL}/privacy`,
                            extraAttrs: {
                                ...this.trackingAttrs('privacy')
                            }
                        },
                        this.sidebarData.has_terms && !this.isSaas && {
                            text: this.$options.i18n.terms,
                            href: termsPath({
                                organizationPath: null
                            }),
                            extraAttrs: {
                                ...this.trackingAttrs('terms')
                            }
                        }
                    ].filter(Boolean)
                },
                helpActions: {
                    items: [
                        {
                            text: this.$options.i18n.shortcuts,
                            action: ()=>{},
                            extraAttrs: {
                                class: 'js-shortcuts-modal-trigger',
                                'data-track-action': 'click_button',
                                'data-track-label': 'keyboard_shortcuts_help',
                                'data-track-property': HELP_MENU_TRACKING_DEFAULTS['data-track-property']
                            },
                            shortcut: '?'
                        }
                    ]
                }
            };
            if (this.sidebarData.show_version_check) {
                groups.versionCheck = {
                    items: [
                        {
                            text: this.$options.i18n.version,
                            href: helpPagePath('update/_index.md'),
                            version: `${this.sidebarData.gitlab_version.major}.${this.sidebarData.gitlab_version.minor}`,
                            extraAttrs: {
                                ...this.trackingAttrs('version_help_dropdown')
                            }
                        }
                    ]
                };
            }
            return groups;
        },
        updateSeverity () {
            return this.sidebarData.gitlab_version_check?.severity;
        }
    },
    methods: {
        trackingAttrs (label) {
            return {
                ...HELP_MENU_TRACKING_DEFAULTS,
                'data-track-label': label
            };
        },
        trackDropdownToggle (show) {
            this.track('click_toggle', {
                label: show ? 'show_help_dropdown' : 'hide_help_dropdown'
            });
        }
    }
};
